export class ID {
    static room = class {
        static id: number = -1;
        static wall: any[] = [];
        static walls = class {
            static id: number = -1;
            static constructPoints = class {
                static inside: any[] = [];
                static outside: any[] = []
            }
        };
        static floor = class {
            static id: number = -1
        }
    };
    static cabinets = class {
        static id: number = -1;
        static items: any[] = []
    };
    static accessories: any[] = [];
    static meshs: any[] = [];
    static geometry: any[] = [];
    static textures: any[] = [];
    static materials: any[] = [];
    static helper: any[] = [];
    static windows = class {
        static id: number = -1;
        static items: any[] = [];
    }
    static setDefault() {
        ID.room.id = -1;
        ID.room.wall.splice(0, ID.room.wall.length);
        ID.room.walls.id = -1;
        ID.room.walls.constructPoints.inside.splice(0, ID.room.walls.constructPoints.inside.length);
        ID.room.walls.constructPoints.outside.splice(0, ID.room.walls.constructPoints.outside.length);
        ID.room.floor.id = -1;
        ID.cabinets.id = -1;
        ID.cabinets.items.splice(0, ID.cabinets.items.length);
        ID.accessories.splice(0, ID.accessories.length);
        ID.meshs.splice(0, ID.meshs.length);
        ID.geometry.splice(0, ID.geometry.length);
        ID.textures.splice(0, ID.textures.length);
        ID.materials.splice(0, ID.materials.length);
        ID.helper.splice(0, ID.helper.length);
        ID.windows.id = -1;
        ID.windows.items.splice(0, ID.windows.items.length);
    }
};

